import React from 'react';
import AdmNivoChart from '../adm_executive_view/AdmNivoChart';
import { findIntervalForDate, cumulateDatapoints, dataExists, createLineConfig } from './admChartUtils';

/**
 * Reusable component for rendering cumulative charts for ADM data
 * Supports arrival and/or closure data
 */
export default function AdmCumulativeChartWrapper(props) {
  const {
    title,
    arrival,
    closure,
    increment,
    d0_date,
    d2_date,
    arrivalColor,
    closureColor,
    chartHeight = '24vw',
    showArrival = true,
    showClosure = true
  } = props;

  // Early return if no data
  if (!arrival && !closure) {
    return null;
  }

  // Find D0 and D2 intervals from the arrival or closure data
  const referenceData = arrival?.actual_processed || closure?.actual_processed;
  const d0_interval = referenceData ? findIntervalForDate(referenceData, d0_date) : null;
  const d2_interval = referenceData ? findIntervalForDate(referenceData, d2_date) : null;

  const lines = [];

  // Add Arrival lines if requested
  if (showArrival && arrival) {
    // Arrival Actual
    if (arrival.actual_processed && arrival.actual_processed.length > 0) {
      const arrivalActual = cumulateDatapoints(arrival.actual_processed);
      lines.push(createLineConfig('Arrival (Actual)', arrivalActual, arrivalColor, 'solid', true));
    }

    // Arrival Predicted
    if (arrival.predicted && arrival.predicted.length > 0) {
      const arrivalPredicted = cumulateDatapoints(arrival.predicted);
      lines.push(createLineConfig('Arrival (Predicted)', arrivalPredicted, arrivalColor, 'dashed', true));
    }
  }

  // Add Closure lines if requested
  if (showClosure && closure) {
    // Closure Actual
    if (closure.actual_processed && closure.actual_processed.length > 0 && dataExists(closure.actual_processed)) {
      const closureActual = cumulateDatapoints(closure.actual_processed);
      lines.push(createLineConfig('Closure (Actual)', closureActual, closureColor, 'solid', true));
    }

    // Closure Predicted
    if (closure.predicted && closure.predicted.length > 0 && dataExists(closure.predicted)) {
      const closurePredicted = cumulateDatapoints(closure.predicted);
      lines.push(createLineConfig('Closure (Predicted)', closurePredicted, closureColor, 'dashed', true));
    }
  }

  return (
    <AdmNivoChart
      title={title}
      lines={lines}
      chartHeight={chartHeight}
      allowHidingLines={true}
      allowHoverTooltip={true}
      xAxisLabel={`Interval (${increment} days)`}
      d0_interval={d0_interval}
      d2_interval={d2_interval}
    />
  );
}
